import {Injectable, signal} from '@angular/core';
import {HttpParams, httpResource} from "@angular/common/http";
import {
  IAppInsightsQueriesResponse,
  IAppInsightsRequestsResponse,
  IErrorLogsSummaryResponse
} from "../interfaces/admin-panel.interface";
import {NonNullableFormBuilder, Validators} from "@angular/forms";
import {AdminPanelFilterForm, AdminPanelFilterModel} from "../models/admin-panel-filter-model";
import {BehaviorSubject} from "rxjs";
import {dateRangeValidator} from "../../shared/validators";
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AdminPanelFilterService {
  public readonly toggleModal = signal(false);

  public readonly filtersValue = signal<AdminPanelFilterModel>(this.form.getRawValue());

  private readonly filters$ = new BehaviorSubject<AdminPanelFilterModel>(this.filtersValue());

  public readonly errorLogsSummaryResource = httpResource<IErrorLogsSummaryResponse>(() => {
    const {DateFrom, DateTo} = this.filtersValue();
    const params = new HttpParams({
      fromObject: {
        DateFrom: moment(DateFrom).format('YYYY-MM-DD') + 'T00:00:00',
        DateTo: moment(DateTo).format('YYYY-MM-DD') + 'T23:59:59',
      }
    });
    return {url: 'dbov2/error-logs/summary', params};
  });

  public readonly appInsightRequestsResource = httpResource<IAppInsightsRequestsResponse>(() => {
    const {DateFrom, DateTo} = this.filtersValue();
    const params = new HttpParams({
      fromObject: {
        StartDate: moment(DateFrom).format('YYYY-MM-DD') + 'T00:00:00',
        EndDate: moment(DateTo).format('YYYY-MM-DD') + 'T23:59:59',
      }
    });
    return {url: 'app-insights-metrics/requests', params};
  });

  public readonly appInsightQueriesResource = httpResource<IAppInsightsQueriesResponse[]>(() => {
    const {DateFrom, DateTo} = this.filtersValue();
    const params = new HttpParams({
      fromObject: {
        StartDate: moment(DateFrom).format('YYYY-MM-DD') + 'T00:00:00',
        EndDate: moment(DateTo).format('YYYY-MM-DD') + 'T23:59:59',
      }
    });
    return {url: 'app-insights-metrics/queries', params};
  });

  private get dates() {
    const today = moment();
    const dateFrom = moment().subtract(1, 'week');

    return {
      dateFrom: dateFrom.toDate(),
      dateTo: today.toDate()
    }
  }

  public get form(): AdminPanelFilterForm {
    const {dateFrom, dateTo} = this.dates;
    return this.formBuilder.group({
      DateFrom: [dateFrom, Validators.required],
      DateTo: [dateTo, Validators.required],
    }, { validators: dateRangeValidator('DateFrom', 'DateTo') });
  }

  constructor(private readonly formBuilder: NonNullableFormBuilder) {
  }

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: AdminPanelFilterModel) {
    this.filters$.next(value);
    this.filtersValue.set(value);
  }

}
